import React, { useEffect } from 'react';
import { recordError } from '@bbkAdminUtils/recordError';
import { useLocation } from '@bbkShared/react-router';

export const NotFoundPage = () => {
  const location = useLocation();

  useEffect(() => {
    recordError(`Could not find page ${location.pathname}`);
  }, []);

  return <>Page is not found</>;
};
